module.exports = __webpack_public_path__ + "img/timer.3c8b5c9a.png";